module.exports = __webpack_public_path__ + "static/media/company-wall-bonitet-2022.dfb8073b.png";